module.exports = new __parcel__URL__("ConfluenceIcon.d49d30a0.svg").toString();